import React from "react";
import {
  TbBarcode,
  TbBuildingBank,
  TbCalendarEvent,
  TbCirclePercentage,
  TbLink,
  TbMapPin,
  TbPencil,
  TbPhone,
  TbTrash,
  TbWallet,
} from "react-icons/tb";
import { useToast } from "../../../context/toast-context";
import {
  Button,
  Col,
  Divider,
  FabButton,
  Flex,
  Gap,
  Icon,
  InputField,
  Link,
  Row,
  SelectField,
  Typography,
} from "../../../ppui";
import { formatToCustomDate } from "../../../utils/common";
import { CardViewBox, CardViewBoxBorder, ContentHeading } from "../../style";
import { BENEFICIARY_FORM_FIELDS } from "./beneficiary-constant";

const BeneficiaryList = ({
  resource,
  handleClickOpen,
  getInputFieldPropsFn,
  setSelectedFile,
  selectedFile,
  setPreviewURL,
  handleSubmitFn,
  handleOpenDeleteDialog,
}) => {
  const { showToastMessage } = useToast();
  if (!resource) {
    throw new Promise(() => {});
  }
  const nomineeRes = resource.read();
  const nomineeList = nomineeRes?.data?.data?.nominees;
  return (
    <>
      {nomineeList?.length > 0 && (
        <ContentHeading>
          <Typography variant="h5" mb="0">
            Nominee Details
          </Typography>

          <Button color="primary" variant="contained" onClick={handleClickOpen}>
            Add New
          </Button>
        </ContentHeading>
      )}
      {nomineeList?.length > 0 ? (
        <>
          <Row>
            {nomineeList?.map((item) => (
              <>
                <Col sm={12} md={6} lg={4}>
                  <CardViewBox>
                    <Row alignItem="center" mb={15} rowGap>
                      <Col>
                        <Typography
                          textCase="capitalize"
                          variant="h6"
                          mb={"0"}
                          strong
                          color="primary"
                        >
                          {item?.name ? item?.name : "N/A"}
                        </Typography>

                        <Typography variant="body2" mb={"0"}>
                          Relationship -{" "}
                          {item?.relationship ? item?.relationship : "N/A"}
                        </Typography>
                      </Col>

                      <Col sm={"auto"} ml={"auto"}>
                        <Flex alignItem="center" gap="10">
                          <FabButton
                            size="sm"
                            icon={<TbTrash />}
                            onClick={() =>
                              handleOpenDeleteDialog(item?.nominee_id)
                            }
                            variant="filled"
                            shape="box"
                          />
                          <FabButton
                            size="sm"
                            icon={<TbPencil />}
                            variant="filled"
                            onClick={() => handleClickOpen(undefined, item)}
                            shape="box"
                          />
                        </Flex>
                      </Col>
                    </Row>
                    <CardViewBoxBorder />

                    <Flex alignItem="center" gap={"5"}>
                      <Icon>
                        <TbCalendarEvent />
                      </Icon>

                      <Typography variant="body2" mb={"0"}>
                        {item?.date_of_birth
                          ? formatToCustomDate(new Date(item?.date_of_birth))
                          : "N/A"}
                      </Typography>
                    </Flex>

                    <Flex alignItem="center" gap={"5"}>
                      <Icon>
                        <TbPhone />
                      </Icon>

                      <Typography variant="body2" mb={"0"}>
                        {item?.contact_no ? item?.contact_no : "N/A"}
                      </Typography>
                    </Flex>

                    <Flex alignItem="center" gap={"5"}>
                      <Icon>
                        <TbCirclePercentage />
                      </Icon>
                      <Typography variant="body2" mb={"0"}>
                        {item?.percentage_of_benefit
                          ? `${item?.percentage_of_benefit}%`
                          : "N/A"} of coverage
                      </Typography>
                    </Flex>

                    <Flex alignItem="center" gap={"5"}>
                      <Icon>
                        <TbMapPin />
                      </Icon>
                      <Typography variant="body2" mb={"0"}>
                        {item?.address ? item?.address : "N/A"}
                      </Typography>
                    </Flex>

                 

                    {item?.employee_nominee_file && (
                      <Flex alignItem="center" gap={"5"}>
                        <Icon>
                          <TbLink />
                        </Icon>

                        <Typography variant="body1" mb={"0"}>
                          Id Proof{" "}
                          <Link to={item?.employee_nominee_file} target="blank">
                            View
                          </Link>
                        </Typography>
                      </Flex>
                    )}

                    <CardViewBoxBorder />
                    <Flex alignItem="center" gap={"5"}>
                      <Icon>
                        <TbBuildingBank />
                      </Icon>
                      <Typography variant="body2" mb={"0"}>
                        {item?.bank_name ? item?.bank_name : "N/A"}
                      </Typography>
                    </Flex>

                    <Flex alignItem="center" gap={"5"}>
                      <Icon>
                        <TbWallet />
                      </Icon>
                      <Typography variant="body2" mb={"0"}>
                       Ac. No: &nbsp; {item?.account_number ? item?.account_number : "N/A"}
                      </Typography>
                    </Flex>

                    <Flex alignItem="center" gap={"5"}>
                      <Icon>
                        <TbBarcode />
                      </Icon>
                      <Typography variant="body2" mb={"0"}>
                        IFSC:&nbsp;
                           { item?.ifcs ? item?.ifcs : "N/A"}
                      </Typography>
                    </Flex>
                  </CardViewBox>
                </Col>
              </>
            ))}
          </Row>
        </>
      ) : (
        <>
          <Typography variant="h5" mb="20">
            Nominee Details
          </Typography>
          <Row rowGap>
            <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
              <InputField
                {...getInputFieldPropsFn(BENEFICIARY_FORM_FIELDS.name.name)}
              />
            </Col>
            <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
              <SelectField
                {...getInputFieldPropsFn(
                  BENEFICIARY_FORM_FIELDS.relationship.name
                )}
              />
            </Col>
            <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
              <InputField
                {...getInputFieldPropsFn(
                  BENEFICIARY_FORM_FIELDS.date_of_birth.name
                )}
              />
            </Col>
            <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
              <InputField
                {...getInputFieldPropsFn(
                  BENEFICIARY_FORM_FIELDS.contact_no.name
                )}
              />
            </Col>
            <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
              <InputField
                {...getInputFieldPropsFn(BENEFICIARY_FORM_FIELDS.address.name)}
              />
            </Col>
            <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
              <InputField
                {...getInputFieldPropsFn(
                  BENEFICIARY_FORM_FIELDS.percentage_of_benefit.name
                )}
              />
            </Col>
            <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
              {/* <InputField
                {...getInputFieldPropsFn(BENEFICIARY_FORM_FIELDS.idProof.name)}
              /> */}
              <InputField
                type="file"
                fullWidth
                label="ID Proof"
                placeholder="Upload File"
                valueSinc={true}
                helperText={selectedFile?.name}
                onChange={(event) => {
                  const file = event.target.files[0];
                  if (file) {
                    const maxSizeInBytes = 2 * 1024 * 1024;
                    if (file.size > maxSizeInBytes) {
                      showToastMessage({
                        message: "File size should not exceed 2 MB.",
                        color: "danger",
                      });
                      return;
                    }
                    const allowedTypes = [
                      "image/jpeg",
                      "image/jpg",
                      "application/pdf",
                      "image/png",
                    ];

                    if (!allowedTypes.includes(file.type)) {
                      showToastMessage({
                        message: "Only JPG/PNG/PDF files are allowed.",
                        color: "danger",
                      });
                      return;
                    }
                    setSelectedFile(file);
                    setPreviewURL(URL.createObjectURL(file));
                  }
                }}
              />
            </Col>
          </Row>
          <Divider gap={20} />
          <Typography variant="h5">Bank Details</Typography>
          <Row rowGap>
            <Col sm={6}>
              <InputField
                {...getInputFieldPropsFn(
                  BENEFICIARY_FORM_FIELDS.bank_name.name
                )}
              />
            </Col>
            <Col sm={6}>
              <InputField
                {...getInputFieldPropsFn(
                  BENEFICIARY_FORM_FIELDS.account_number.name
                )}
              />
            </Col>
            <Col sm={6}>
              <InputField
                {...getInputFieldPropsFn(BENEFICIARY_FORM_FIELDS.ifcs.name)}
              />
            </Col>
          </Row>
          <Gap height={100} />
          <Flex justifyContent="flex-end" gap={"10"}>
            <Button onClick={() => {}} variant="outlined">
              Cancel
            </Button>

            <Button
              color="primary"
              onClick={handleSubmitFn}
              variant="contained"
            >
              Submit
            </Button>
          </Flex>
        </>
      )}
    </>
  );
};

export default BeneficiaryList;
